import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {HistoryHttpClientService} from "../../../../data/history-http-client.service";
import {PrintService} from "../../../../services/print.service";
import {History} from "../../../../models/History/history";
import {UserHttpClientService} from "../../../../data/user-http-client.service";
import {merge} from "rxjs";
import {PaymentType} from "../../../../models/History/payment-type.enum";

interface Criteria {
    finServiceId: number;
    finServiceName: string;
    pageNumber: number;
    pageSize: number;
    fromDate: string;
    toDate: string;
    paymentType: PaymentType;
}

@Component({
    templateUrl: "./print-child-history.component.html",
    styleUrls: ["./print-child-history.component.css"]
})
export class PrintChildHistoryComponent implements OnInit {
    criteria: Criteria = {} as Criteria;
    historyRecord: History = {} as History;

    datePrinted: Date = new Date();

    userName: string;
    paymentTypeValue: string;

    constructor(route: ActivatedRoute,
                private historyHttpClient: HistoryHttpClientService,
                private userHttpClient: UserHttpClientService,
                private printService: PrintService) {
        const criteria = route.snapshot.params["criteria"];
        this.criteria = JSON.parse(criteria) as Criteria;
    }

    ngOnInit() {
        this.paymentTypeValue = this.getEnumKeyByValue();

        const observable = merge(this.getHistoryV2(), this.getUserName());
        observable.subscribe({
            next: value => {
                if (typeof value === "object") {
                    this.historyRecord = value as History;
                } else {
                    this.userName = value as string;
                }
            },
            complete: () => {
                this.printService.onDataReady();
            }
        });
    }

    getEnumKeyByValue(): string {
        return PaymentType[this.criteria.paymentType];
    }

    getHistoryV2() {
        return this.historyHttpClient.SearchHistory(this.criteria.finServiceId,
            this.criteria.pageNumber,
            this.criteria.pageSize,
            this.criteria.fromDate,
            this.criteria.toDate,
            this.criteria.paymentType);
    }

    getUserName() {
        return this.userHttpClient.getUserName();
    }
}
